module.exports = __webpack_public_path__ + "img/product32_img01.ce9be273.png";